import { createContext } from 'react';

export const ReplicaContext = createContext<ReplicaContextProps>({
	isMenuOpen: false,
	setIsMenuOpen: () => {},
	isSidebarOpen: true,
	setIsSidebarOpen: () => {},
	toggleSidebar: () => {},
	toggleMenu: () => {},
	setViewMode: () => {},
});

interface ReplicaContextProps {
	isMenuOpen: boolean;
	setIsMenuOpen: (value: boolean) => void;
	toggleMenu: () => void;
	isSidebarOpen: boolean;
	setIsSidebarOpen: (value: boolean) => void;
	toggleSidebar: () => void;
	setViewMode: (value: 'single' | 'double') => void;
}
